<template src="../templates/normal_fcont_20.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'

import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import PrintButton from '../components/PrintButton'
import UseDesignPaperList from '../components/UseDesignPaperList'
import InfoMachineTranslation from '../components/InfoMachineTranslation'
import { Carousel,Slide } from 'uiv'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink'
import AppDownloadCreative from '../components/AppDownloadCreative'
export default {
  name: 'app',
  components: {
   LabelFunMessage,FuncSearchRecommendLink,Carousel,Slide,FuncSearchGalleryQR,
   PrintButton,UseDesignPaperList,InfoMachineTranslation,AppDownloadCreative
  },
  data() {
    return {
      app_root: process.env.VUE_APP_ROOT
    }
  },
metaInfo() {
    return {
      title: this.$store.state.messages.messages['20-1'],
    meta: [
      { name: 'description', content: this.$store.state.messages.messages['20-2']}
    ]};
  }
};
</script>
<style />


